import React from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import MuiDialogContent, { DialogContentProps as MuiDialogContentProps } from '@material-ui/core/DialogContent';

const styles = () =>
  createStyles({
    root: {},
  });

export interface DialogContentProps extends Omit<MuiDialogContentProps, 'classes'>, WithStyles<typeof styles> {}

const DialogContentComponent: React.FC<DialogContentProps> = ({ classes, ...rest }) => (
  <MuiDialogContent
    classes={{
      root: classes.root,
    }}
    {...rest}
  />
);

export const DialogContent = withStyles(styles, { name: 'LumaDialogContent' })(DialogContentComponent);
